import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Автоматический редирект на главную через 3 секунды
    const timer = setTimeout(() => {
      navigate('/', { replace: true });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        textAlign: 'center',
        gap: 3
      }}
    >
      <Typography variant="h4" color="error" gutterBottom>
        404 - Страница не найдена
      </Typography>
      
      <Typography variant="body1" color="text.secondary">
        Страница, которую вы ищете, не существует.
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <CircularProgress size={20} />
        <Typography variant="body2" color="text.secondary">
          Перенаправление на главную страницу...
        </Typography>
      </Box>
    </Box>
  );
};

export default NotFound;
